import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(async () => {
  try {
    const { restoreLoginState } = useLogin()
    await restoreLoginState()
  } catch {
    // auth cookies may not exist — no user to restore
  }
})
